"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
var Advertising = function (_a) {
    var size = _a.size, title = _a.title, theme = _a.theme, _b = _a.color, color = _b === void 0 ? utils_1.themeToColor(theme) : _b, svgProps = __rest(_a, ["size", "title", "theme", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', style: __assign({ color: color }, svgProps.style), viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "advertising-app-icon" },
            react_1.default.createElement("path", { d: "M16.8288 6.25806V14.7061L19.7792 20.6965L16.8288 20.0799V23.8933L26.5141 25.9167L16.8288 6.25806Z", fill: "#00B2AE" }),
            react_1.default.createElement("path", { d: "M15.2741 6.25806V14.7061L12.3237 20.6965L15.2741 20.0799V23.8933L5.5888 25.9167L15.2741 6.25806Z", fill: "currentcolor" }))));
};
exports.default = Advertising;
